import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastComponent } from './shared/toast/toast.component';

// Configuración de Local
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es'; // Español

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { UUIDInterceptor } from './core/interceptor/uuid.interceptor';

import { NavbarModule } from './modules/navbar/navbar.module';
import { FooterModule } from './modules/footer/footer.module';
import { ContactoModule } from './modules/contacto/contacto.module';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { ComponentesModule } from './componentes/componentes.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

// Importaciones para ngx-translate
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoaderInterceptor } from './core/interceptor/loader.interceptor';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';


// Función de carga de traducciones
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

interface NgxSpinnerConfig {
    type?: string;
}

registerLocaleData(localeEs); // Registra el locale español

@NgModule({
    declarations: [
        AppComponent,
        ToastComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        MatButtonToggleModule,
        BrowserModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule,
        NavbarModule,
        FooterModule,
        ContactoModule,
        ComponentesModule, 
        BrowserModule,
        HttpClientModule,
        NgxSpinnerModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [
            // {
            //     provide: HTTP_INTERCEPTORS,
            //     useClass: UUIDInterceptor,
            //     multi: true
            // },
            { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
            { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
            ,
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }
